var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMax({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.023 0H17.977C8.04859 0 0 8.04859 0 17.977V54.023C0 63.9514 8.04859 72 17.977 72H54.023C63.9514 72 72 63.9514 72 54.023V17.977C72 8.04859 63.9514 0 54.023 0Z",
    fill: "url(#paint0_linear_142_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.023 0H17.977C8.04859 0 0 8.04859 0 17.977V54.023C0 63.9514 8.04859 72 17.977 72H54.023C63.9514 72 72 63.9514 72 54.023V17.977C72 8.04859 63.9514 0 54.023 0Z",
    fill: "url(#paint1_radial_142_18)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5911 63.2396C31.1906 63.2396 28.6809 62.4512 24.3185 59.2976C21.5591 62.8454 12.8211 65.618 12.44 60.8744C12.44 57.3136 11.6516 54.3046 10.758 51.0196C9.69374 46.9724 8.48486 42.4655 8.48486 35.935C8.48486 20.3379 21.2832 8.604 36.4466 8.604C51.6231 8.604 63.5148 20.9161 63.5148 36.0795C63.5657 51.0084 51.5199 63.16 36.5911 63.2396ZM36.8145 22.0855C29.4299 21.7045 23.6746 26.8159 22.4 34.8312C21.3488 41.4669 23.2147 49.5479 24.8046 49.9684C25.5667 50.1523 27.4852 48.6018 28.6809 47.4061C30.6581 48.772 32.9605 49.5923 35.356 49.7844C43.0076 50.1525 49.5457 44.3272 50.0595 36.684C50.3585 29.0245 44.4672 22.537 36.8145 22.0987V22.0855Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_142_18",
    x1: 8.48498,
    y1: 54.7586,
    x2: 72,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#5533EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9933DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_142_18",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.71294 -31.6213) rotate(51.356) scale(87.3732 36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.b8913cd72e961085edeff9aa8a90231a.svg";
export { ForwardRef as ReactComponent };